import { Tooltip } from 'antd';
import { CSSProperties, useMemo } from 'react';

import { DockingBillingStatusType } from '../../types';
import { dockingBillingStatusList } from '../../utils/lists';
import { Tag } from '../antd/Tag';

// Cobre tanto a atracação sem status quanto um valor que o backend passe a
// devolver e a interface ainda não conheça.
const unknownStatus = {
  id: 'UNKNOWN',
  name: 'Não informado',
  className: 'unknown',
};

type DockingBillingStatusTagProps = {
  status?: DockingBillingStatusType | null;
  rmRecordKey?: string | null;
  rmErrorReason?: string | null;
  style?: CSSProperties;
};

export function DockingBillingStatusTag(props: DockingBillingStatusTagProps) {
  const { status, rmRecordKey, rmErrorReason, style } = props;

  const selectedStatus = useMemo(() => {
    return (
      dockingBillingStatusList.find((item) => item.id === status) ||
      unknownStatus
    );
  }, [status]);

  // O protocolo só faz sentido no desfecho confirmado e o motivo no de erro;
  // sem nenhum dos dois a badge vai sem tooltip.
  const detail = useMemo(() => {
    if (status === 'CONFIRMED_BY_FINANCE' && rmRecordKey) {
      return `Protocolo do RM: ${rmRecordKey}`;
    }
    if (status === 'FINANCE_SEND_ERROR' && rmErrorReason) {
      return rmErrorReason;
    }
    return '';
  }, [status, rmRecordKey, rmErrorReason]);

  const tag = (
    <Tag
      style={style}
      className={`docking-billing-status ${selectedStatus.className}`}
    >
      {selectedStatus.name}
    </Tag>
  );

  return detail ? (
    <Tooltip title={<span style={{ whiteSpace: 'pre-line' }}>{detail}</span>}>
      {tag}
    </Tooltip>
  ) : (
    tag
  );
}
